// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1hl6v","notes":"Notes_notes__sKff4","note":"Notes_note__3OhuE","markdown":"Notes_markdown__3svyM"};